import { captureLoaded } from '../../lib/funnels/functions/v1/metrics/captureLoaded'
import { handleDownsellClick } from '../../lib/funnels/functions/v1/default/handleDownsellClick'
import { getThanksParams } from '../../lib/funnels/functions/v1/html/getThanksParams'

import '../thanks/index.css'

const offers = [
  {
    name: 'Lending For Bad Credit',
    title: 'Receive up to $40,000',
    bullets: [
      'Make a request in 2 minutes',
      'This is a free service that does not affect your credit',
      'Any credit is welcomed',
    ],
    link: 'https://www.catrkr.com/rd/r.php?sid=633&pub=221168',
    image: '/media/offers/lfbc.webp',
    cta: 'GET STARTED',
    slug: 'lfbc-offerwall',
  },
  {
    name: 'Friends Finance',
    title: 'Fast Funding Solutions! Ranging from $100 to $40,000',
    bullets: [
      'Credit Issues? Your Request will still be considered.',
      'Join over $500 Million in approved loans!',
      'Get a decision within minutes.',
    ],
    link: 'https://www.catrkr.com/rd/r.php?sid=658&pub=221168',
    image: '/media/offers/friendsfinance.png',
    cta: 'APPLY NOW',
    slug: 'friendsfinance-offerwall',
  },
  {
    name: 'Loan Connect Pros',
    title: 'Need cash in a hurry?',
    bullets: [
      'Submit a request in just a few minutes',
      'All credits considered',
      'Funds available as soon as the next business day',
    ],
    link: 'https://www.catrkr.com/rd/r.php?sid=836&pub=221168',
    image: '/media/offers/loanconnectpros.png',
    cta: 'GET STARTED',
    slug: 'loanconnectpros-offerwall',
  },
]

document.addEventListener('DOMContentLoaded', async () => {
  captureLoaded()

  // const OFFERS_API_URL =
  //   'https://blog.turbodevhub.com/api/listings?sort[0]=Position:asc&populate[BulletPoints][fields][0]=*&populate[Logo][fields][0]=*&fields[0]=*&publicationState=live&locale[0]=en'

  // const strapiOffers = await fetchWithCache(
  //   OFFERS_API_URL,
  //   'td_offers',
  //   24 * 60 * 60, // (1 day)
  // )

  // transform strapiOffers to pass to offerTemplate
  // const transformedOffers = strapiOffers.data.map(
  //   (/** @type {StrapiOffers} */ item) => {
  //     const attr = item.attributes
  //     return {
  //       slug: attr.Slug,
  //       link: attr.Tracking_URL,
  //       name: attr.Name,
  //       image: attr.Logo?.data?.attributes?.url || '',
  //       title: attr.Headline,
  //       cta: attr.CTA,
  //       cta2: attr.Secondary_CTA,
  //       link2: attr.Secondary_URL,
  //       bullets: Array.isArray(attr.BulletPoints)
  //         ? attr.BulletPoints.map((bp) => bp.Point)
  //         : [],
  //       disclaimer: attr.Short_Disclaimer,
  //       disclaimerLong: parseEditorJsHtml(attr.Disclaimer),
  //       position: attr.Position,
  //       enabled: attr.Enabled,
  //       availableStates: attr.Available_States,
  //       restrictedStates: attr.Restricted_States,
  //     }
  //   },
  // )

  const {
    email,
    eventID,
    firstName,
    lastName,
    phone,
    state,
    zipcode,
    trksub,
    encodedSub1,
  } = getThanksParams()

  /**
   * Create offer HTML template
   * @param {ThanksOffers} offer
   * @returns {string}
   */
  const offerTemplate = (offer) => {
    const {
      slug,
      link,
      name,
      image,
      title,
      cta,
      cta2,
      link2,
      bullets,
      disclaimer,
      disclaimerLong,
    } = offer

    const offerBullets = bullets
      .map((bullet) => {
        return `<li>${bullet}</li>`
      })
      .join('')

    let action2 = ''
    if (link2 && cta2) {
      action2 = `<a href="${link2}">${cta2}</a>`
    }

    let replacedLink = link
      .replace(/\{email}/g, email || '')
      .replace(/\{first}/g, firstName || '')
      .replace(/\{last}/g, lastName || '')
      .replace(/\{phone}/g, phone || '')
      .replace(/\{state}/g, state || '')
      .replace(/\{trksub}/g, trksub || '')
      .replace(/\{zipcode}/g, zipcode || '')
      .replace(/\{clickId}/g, eventID || '')
      .replace(/\{encodedSub1}/g, encodedSub1 || '')

    // Append tracking params if present
    const searchParams = new URLSearchParams(window.location.search)
    const paramMappings = [
      ['c1', 'c1'],
      ['sub1', 'c2'],
      ['sub1', 'sub1'],
    ]
    paramMappings.forEach(([source, target]) => {
      const value = searchParams.get(source)
      if (value) {
        const separator = replacedLink.includes('?') ? '&' : '?'
        replacedLink = `${replacedLink}${separator}${target}=${encodeURIComponent(value)}`
      }
    })

    return `
      <div class="offer-card" data-offer="${slug}">
        <div class="img-container">
          <a href="${replacedLink}"><img alt="${name}" src="${image}" class="offer-logo" /></a>
          <span class="short-disclaimer">${disclaimer ? disclaimer : ''}</span>
        </div>
        <div class="content-container">
            <h3><a href="${replacedLink}">${name}</a></h3>
            <h4>${title}</h4>
            <ul>
              ${offerBullets}
            </ul>
            <div class="long-disclaimer">${disclaimerLong ? disclaimerLong : ''}</div>
            <span class="short-disclaimer-mobile">${disclaimer ? disclaimer : ''}</span>
        </div>
        <div class="action-container">
          <a href="${replacedLink}">${cta}</a>
          ${action2}
        </div>
      </div>
    `
  }

  const offersContainer = document.getElementById('offers')
  if (!offersContainer) {
    throw Error('unexpected: offers container not found')
  }

  const finalOffers = [...offers]

  offersContainer.innerHTML = ''

  finalOffers.forEach((o) => {
    const offer = /** @type {ListingOffers} */ (o)

    offersContainer.innerHTML += offerTemplate(offer)
  })

  const links = offersContainer.querySelectorAll('.offer-card a')
  links.forEach((link) => {
    const href = link?.getAttribute('href')
    const slug = link?.closest('.offer-card')?.getAttribute('data-offer')

    if (!slug || !href) {
      throw Error('no valid slug/href, events not attached')
    }

    link.addEventListener('click', () => {
      handleDownsellClick(slug)
    })
  })
})
